import { LockedErrorBox } from "common/ui-components/LockedErrorBox";

import { Text } from "@bps/fluent-ui";

export const AuthorizationErrorBox = () => {
  return (
    <LockedErrorBox
      heading="Access denied"
      children={
        <>
          <Text>You do not have permission to access Premier Online.</Text>
          <Text>
            Please check your user permissions or contact your Bp Premier
            administrator.
          </Text>
        </>
      }
      resolutionText="Alternatively"
    />
  );
};
